import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
const { defineMultiStyleConfig: i, definePartsStyle: e } = t([
  "container",
  "stepDetails",
  "stepDetailsLabel",
  "icon",
  "verticalDivider",
  "status"
]), o = e({
  container: {
    paddingX: "22px",
    paddingY: 6,
    maxWidth: "none",
    "[data-no-click]": {
      cursor: "not-allowed"
    },
    "[aria-disabled]:not([data-no-click])": {
      cursor: "not-allowed",
      opacity: 0.5
    }
  },
  stepDetails: {
    cursor: "pointer",
    color: "teal.500",
    ".gravity-steps__step-label": {
      fontFamily: "body",
      fontSize: "sm",
      fontWeight: "bold",
      lineHeight: "24px"
    },
    ":hover, :focus": {
      ".gravity-steps__step-details": {
        color: "teal.600",
        background: "gray.100",
        borderRadius: "lg"
      },
      _focusVisible: { outline: "none" },
      ".gravity-steps__step-icon": {
        "svg circle": {
          stroke: "teal.600",
          fill: "teal.600"
        }
      },
      ".gravity-steps__step-number": {
        color: "white"
      }
    }
  },
  stepDetailsLabel: {
    paddingX: 2,
    paddingY: 1
  },
  icon: {
    position: "relative",
    width: "20px",
    height: "20px",
    "svg circle": {
      stroke: "gray.600",
      fill: "none"
    },
    ".gravity-steps__step-number": {
      color: "gray.600",
      width: "100%",
      height: "100%",
      textAlign: "center",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "700",
      position: "relative",
      bottom: "20px",
      lineHeight: "20px"
    }
  },
  verticalDivider: {
    marginLeft: 4,
    border: "2px solid var(--sgi-colors-gray-200)",
    height: "8px",
    width: 0
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  }
}), s = e({
  stepDetails: {
    color: "teal.700",
    ":hover, :focus": {
      ".gravity-steps__step-details": {
        color: "teal.700"
        // background: 'white',
      },
      _focusVisible: { outline: "none" },
      ".gravity-steps__step-icon": {
        "svg circle": {
          stroke: "teal.700",
          fill: "teal.700"
        }
      },
      ".gravity-steps__step-number": {
        color: "white"
      }
    }
  }
}), a = e({
  stepDetails: {
    color: "teal.500",
    "svg.gravity-steps__step-icon": {
      color: "green.500"
    },
    hr: {
      borderColor: "green.500"
    }
  }
}), l = e({}), n = i({
  baseStyle: o,
  variants: {
    active: s,
    complete: a,
    default: l
  }
});
export {
  n as default,
  n as stepsTheme
};
